import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sessionUrl: String
  }

  async start(event) {
    event.preventDefault();
    const button = event.currentTarget;
    button.disabled = true;

    await this.loadStripeJs();

    Rails.ajax({
      url: this.sessionUrlValue,
      type: "POST",
      dataType: "json",
      success: (data) => {
        const { sessionId, publicKey } = data;
        const stripe = Stripe(publicKey);
        stripe.redirectToCheckout({ sessionId });
      },
      error: (err) => {
        button.disabled = false;
        console.error("Failed to create checkout session");
      }
    });
  }

  async loadStripeJs() {
    if (!window.Stripe) {
      await new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }
}
